<template>
  <b-card title="Окупаемость пакетов" class="h-100">
    <small class="text-muted d-block mb-1">Топ-10 по ROI (за всё время)</small>
    <b-overlay :show="isLoading" rounded="sm">
      <vue-good-table
        :rows="rows"
        :columns="columns"
        :pagination-options="{ enabled: false }"
        :sort-options="{ enabled: false }"
      >
        <template slot="emptystate">
          <div class="text-center text-muted py-2">
            {{ errorText || 'Нет данных' }}
          </div>
        </template>
        <template slot="table-row" slot-scope="props">
          <span
            v-if="props.column.field === 'name'"
            class="finance-roi-pack-name"
            :title="props.row.name"
          >
            {{ props.row.name || '—' }}
          </span>
          <span v-else-if="props.column.field === 'games_count'">
            {{ props.row.games_count }}
          </span>
          <span
            v-else-if="props.column.field === 'profit'"
            :class="`text-${profitVariant(props.row.profit)}`"
          >
            {{ formatRub(props.row.profit) }}
          </span>
          <span v-else-if="props.column.field === 'roi'">
            <b-badge :variant="roiVariant(props.row.roi)">
              {{ formatRoi(props.row.roi) }}
            </b-badge>
          </span>
          <span v-else>{{ props.formattedRow[props.column.field] }}</span>
        </template>
      </vue-good-table>
      <div class="text-right mt-1">
        <b-button
          variant="outline-primary"
          size="sm"
          :to="{ name: 'finance', query: { tab: 'packs-roi' } }"
        >
          Все пакеты →
        </b-button>
      </div>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BOverlay, BBadge, BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  formatRub, profitVariant, roiVariant, formatRoi,
} from '@/views/finance/utils'

export default {
  components: {
    BCard, BOverlay, BBadge, BButton, VueGoodTable,
  },
  setup() {
    const toast = useToast()
    const isLoading = ref(false)
    const rows = ref([])
    const errorText = ref('')

    const columns = [
      { label: 'Пакет', field: 'name' },
      { label: 'Игр', field: 'games_count', type: 'number' },
      { label: 'Прибыль', field: 'profit', type: 'number' },
      { label: 'ROI', field: 'roi', type: 'number' },
    ]

    const fetchData = () => {
      isLoading.value = true
      errorText.value = ''
      store.dispatch('app-finance/fetchPacksRoi', { include_archived: false, min_games: 0 })
        .then(response => {
          const list = (response.data && response.data.data && response.data.data.data) || []
          rows.value = list.slice(0, 10)
        })
        .catch(err => {
          errorText.value = 'Не удалось загрузить'
          toast({
            component: ToastificationContent,
            props: {
              title: err.response?.data?.message || 'Ошибка загрузки отчёта об окупаемости',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          isLoading.value = false
        })
    }

    fetchData()
    // Перезапрос после пересборки серверного кеша (кнопка «Обновить» в шапке раздела)
    watch(() => store.state['app-finance'].refreshVersion, fetchData)

    return {
      isLoading, rows, errorText, columns,
      formatRub, profitVariant, roiVariant, formatRoi,
    }
  },
}
</script>

<style lang="scss" scoped>
.finance-roi-pack-name {
  display: inline-block;
  max-width: 14rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
